import { useState } from 'react'
import './styles.scss'
import { DetailTableM024 } from './detail';
import { AddProtocolPopup } from '../popup/addProtocol';
import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks';
import Button from '../../../../../ui/molecules/button';
import { PopupForm } from '../../../../../ui/organisms/popupForm';
import { CompanyFolderDetailDTO } from '../../../../cartellaAziendale/dataService/dto';
import { setCFDetailCreationRequestCustomerId, setCFDetailCreationRequestEntryProtocolAttachmentId } from '../../../../cartellaAziendale/slice';
import { M024DetailDTO } from '../../dataService/dto';
import { setUpdateActiveM024DetailsRequest } from '../../slice';

interface Props {
    id: string
    code: number
    title: string
    numOfDetails: number
    documentType: 'VALUTAZIONE' | 'RIESAME' | 'DECISIONE'
    onEdit?: () => void
    protocolIds: string[]
}

export function ListItemM024(props: Props) {
    const dispatch = useAppDispatch()
    const customerState = useAppSelector(state => state.clienti)
    const m024State = useAppSelector(state => state.m024)
    const sessionState = useAppSelector(state => state.session)
    const { id, code, title, numOfDetails, protocolIds, onEdit, documentType } = props
    const [addPopupShow, setAddPopupShow] = useState<boolean>(false)

    const onNewProtocol = () => {
        dispatch(setCFDetailCreationRequestEntryProtocolAttachmentId(id))
        dispatch(setCFDetailCreationRequestCustomerId(sessionState.selected.customerId))
        setAddPopupShow(true)
    }

    const handleProtocols = () => {
        const protGroups: { pd: M024DetailDTO, index: number }[] = []
        const activeReq = m024State.activeM024DetailsUpdateRequest
        for (let i = 0; i < activeReq.length; i++) {
            if (protocolIds.includes(activeReq[i].id!)) {
                protGroups.push({ pd: activeReq[i], index: i })
            }
        }
        return protGroups
    }

    return (
        <div style={{ backgroundColor: '#fff', borderRadius: '20px' }}>
            <div className='container-li-ca' style={{ padding: '10px 10px 20px 10px' }}>

                <div className='code'>
                    <span>{code < 10 ? `0${code}` : code}</span>
                </div>

                <div className='content'>
                    <span className='title' style={{ color: '#182B2E' }}>{`${title} - `}</span>
                    <span className='title' style={{ color: 'orange' }}>{`[${numOfDetails}]`}</span>
                </div>

                <div>
                    <Button
                        variant='solid'
                        color='orange'
                        iconPosition='plus'
                        size='plus'
                        label='+'
                        onClick={() => onNewProtocol()}
                    />
                </div>

            </div>

            <div>
                <DetailTableM024
                    documentType={documentType}
                    protocols={handleProtocols()}
                />
            </div>

            {
                addPopupShow && (
                    <PopupForm title="Aggiungi protocollo" close={() => {
                        setAddPopupShow(false)
                    }}>
                        <AddProtocolPopup close={() => setAddPopupShow(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}